import React, { useContext, useEffect, useState } from "react";
import PropTypes from "prop-types";

import { useHistory } from "react-router-dom";
import { Input, Field, Control, Label, Button, Icon, Column } from "rbx";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

import { useApolloClient, useLazyQuery } from "react-apollo";

import { SINGLE_ROUTE_QUERY } from "../../../../graphql/Routes/Routes.graphql";

import { NewOrderOrderDetailForm } from "../../../../components/Orders";

import {
  RouteSelect,
  CustomerSelect,
  BookingCodeSelect,
  SystemCodeSelect,
  BooleanInput
} from "../../../../components/inputs";

import {
  CustomerGridSelectModal,
  RouteGridSelectModal
} from "../../../../components/modals";

import { ALL_ROUTE_PRODUCTS_QUERY } from "../../../../graphql/Routes/RouteProducts.graphql";

import Locations from "./Locations";
import TimeFrames from "./TimeFrames";

import { OrderDetails } from "../components";
import HorizontalRule from "../../../../styles/HorizontalRule";

import { SINGLE_SYSTEM_CODE_QUERY } from "../../../../graphql/SystemCodes/SystemCodes.graphql";

import { SINGLE_PRODUCT_QUERY } from "../../../../graphql/Products/Products.graphql";

import { ModalContext } from "../../../../components/ModalProvider";
import { useSystemCodes } from "../../../../utils/hooks";
import TripList from "../../Trips/TripList";

function Summary({
  adding,
  order,
  editing,
  onChange,
  onTimeFramesChange,
  handleChangeRoute,
  handleChangeCustomer,
  orderDetails,
  setOrderDetails
}) {
  const SystemCodes = useSystemCodes({
    Category_in: ["BookingCodes", "Product"],
    CodeName_in: ["BookCatg", "ProductCatg"],
    CodeId_in: ["O", "SALE"]
  });
  const client = useApolloClient();
  const history = useHistory();
  const [codes, setCodes] = useState(null);
  const [canEdit, setCanEdit] = useState(!!editing);
  const [canEditRoute, setCanEditRoute] = useState(true);

  const [getSystemCode, { data: GetSystemCodeData }] = useLazyQuery(
    SINGLE_SYSTEM_CODE_QUERY
  );

  const { setModalOpen } = useContext(ModalContext);

  useEffect(() => {
    if (SystemCodes?.data && !codes) {
      setCodes({
        BookingCatOrders: SystemCodes.data.find(code => code.CodeId === "O"),
        ProductCatSale: SystemCodes.data.find(code => code.CodeId === "SALE")
      });
    }
  }, [SystemCodes, codes]);

  useEffect(() => {
    const orderStatus = order?.StatusRecIdRef;
    if (orderStatus) {
      getSystemCode({
        variables: { where: { RecId: parseInt(orderStatus, 10) } }
      });
    }
  }, [getSystemCode, order.StatusRecIdRef]);

  useEffect(() => {
    const listOrder = GetSystemCodeData?.SystemCode?.ListOrder;

    // booked order
    setCanEdit(listOrder <= 5);
    setCanEditRoute(listOrder <= 5);
  }, [GetSystemCodeData]);

  const getOrderDetailsFromRouteProduct = rp => ({
    ProductRecIdRef: {
      value: rp.Product?.RecId,
      name: "ProductRecIdRef",
      label: rp.Product?.ProductCode,
      otherLabel: rp.Product?.ProductCode,
      description: rp.Product?.Description
    },
    Product: rp.Product,
    Description: rp.ProdDescription,
    Quantity: 1,
    UOMRecIdRef: rp?.UOM ? rp.UOM.RecId : rp.Product?.UOMRecIdRef,
    TariffRecIdRef: rp.TariffCodeRecIdRef,
    HazmatCode: rp.Product?.HazmatCode,
    ProdCatgRecIdRef: rp.Product?.ProductCatgRecIdRef,
    Rate: rp.Rate,
    InternalComm: rp.InternalComm,
    ExternalComm: rp.ExternalComm
  });

  const handleSelectRoute = async (route, e) => {
    if (adding) {
      const { data: RouteData } = await client.query({
        query: SINGLE_ROUTE_QUERY,

        variables: {
          where: { RecId: route ? route.RecId : parseInt(e.value) || null }
        },

        fetchPolicy: "network-only"
      });

      const { data: RouteProductData } = await client.query({
        query: ALL_ROUTE_PRODUCTS_QUERY,
        variables: {
          where: {
            RouteRecIdRef: route ? route.RecId : parseInt(e.value) || null
          }
        }
      });

      if (
        RouteData &&
        RouteData.Route &&
        RouteProductData &&
        RouteProductData.RouteProducts
      ) {
        setOrderDetails(
          RouteProductData.RouteProducts.map(getOrderDetailsFromRouteProduct)
        );

        handleChangeRoute({
          RouteSelected: {
            value: RouteData.Route.RecId,
            name: "RouteRecIdRef",
            label: `${RouteData.Route?.RouteId} - ${RouteData.Route?.PickupLocation?.City}, ${RouteData.Route?.PickupLocation?.State} / ${RouteData.Route?.DeliveryLocation?.City}, ${RouteData.Route?.DeliveryLocation?.State}`
          },
          Route: RouteData.Route,
          NonBill: RouteData.Route.NonBill,
          DeliveryLocation: RouteData.Route.DeliveryLocation,
          PickupLocation: RouteData.Route.PickupLocation,
          BillToRecIdRef: RouteData.Route.BillToRecIdRef,
          RouteRecIdRef: RouteData.Route.RecId,
          EstimatedLoad: RouteData.Route.LoadTime,
          EstimatedUload: RouteData.Route.UnloadTime,
          EstimatedTravel: RouteData.Route.TravelTime,
          LoadTypeRecIdRef: RouteData.Route.LoadTypeRecIdRef,
          StartLocationRecIdRef: RouteData.Route.StartLocationRecIdRef,
          PickupLocationRecIdRef: RouteData.Route.PickupLocationRecIdRef,
          DeliveryLocationRecIdRef: RouteData.Route.DeliveryLocationRecIdRef,
          EndingLocationRecIdRef: RouteData.Route.EndingLocationRecIdRef,
          StartLoc_SI:
            RouteData.Route.StartLocation?.SpecialExternalInstructions,
          PickupLoc_SI:
            RouteData.Route.PickupLocation?.SpecialExternalInstructions,
          DeliveryLoc_SI:
            RouteData.Route.DeliveryLocation?.SpecialExternalInstructions,
          EndLoc_SI:
            RouteData.Route.EndingLocation?.SpecialExternalInstructions,
          LoadedMiles: RouteData.Route.LoadedMiles,
          BookingCodeRecIdRef: RouteData.Route.BookingCodeRecIdRef,
          TariffRecIdRef: RouteData.Route.TariffRecIdRef,
          IndustrialFlag: RouteData.Route.IndustrialFlag,
          MotorOilFlag: RouteData.Route.MotorOilFlag,
          Tolls: RouteData.Route.Tolls,
          ChargeForTolls: RouteData.Route.ChargeForTolls,
          PaymentTermsRecIdRef: RouteData.Route.PaymentTermsRecIdRef
        });
      } else {
        handleChangeRoute({ RouteRecIdRef: "", BillToRecIdRef: "" });
        setOrderDetails([]);
      }
    } else {
      handleChangeRoute({
        RouteRecIdRef: route ? route.RecId : parseInt(e.value) || null
      });
    }
  };
  const handleSelectCustomer = data => {
    onChange({
      target: { name: "CustomerRecIdRef", value: data.RecId }
    });
  };

  const handleOrderDetailChange = index => async e => {
    const ods = [...orderDetails];
    if (e.value && !e.target) {
      ods[index][e.name] = {
        ...e,
        label: e.otherLabel
      };
      ods[index].Description = e.description;
    } else {
      ods[index][e.target.name] = e.target.value;
      if (e.target.name === "ProductRecIdRef") {
        const { data: ProductData } = await client.query({
          query: SINGLE_PRODUCT_QUERY,
          variables: {
            where: {
              RecId: parseInt(ods[index].ProductRecIdRef)
            }
          }
        });
        ods[index].Description = ProductData.Product.Description;
      }
    }
    setOrderDetails(ods);
  };

  const handleCustomerSelect = e => {
    handleChangeRoute({});
    setOrderDetails([]);
    handleChangeCustomer(e);
  };

  const closeModal = () => setModalOpen(false, "");

  const toggleShowCustomerTable = () => {
    setModalOpen(
      true,
      <CustomerGridSelectModal
        where={{ Active: true, OrderCust: true }}
        onModalClose={closeModal}
        onRowClick={data => {
          handleSelectCustomer(data);
          setModalOpen(false, "");
        }}
      />
    );
  };

  const toggleShowRouteTable = () => {
    setModalOpen(
      true,
      <RouteGridSelectModal
        where={
          order.CustomerRecIdRef
            ? { Status: true, CustomerRecIdRef: order.CustomerRecIdRef }
            : { Status: true }
        }
        onModalClose={closeModal}
        onRowClick={data => {
          handleSelectRoute(data);
          closeModal();
        }}
      />
    );
  };

  const handleAddNewRoute = () => {
    history.push("/dispatch/routes");
  };

  return (
    <div className="order-tab-container summary">
      <div className="row" style={{ gridTemplateColumns: "1.3fr 1.3fr 2fr" }}>
        <Field>
          <Control>
            <CustomerSelect
              addons={[
                <Button
                  disabled={!editing || !canEdit}
                  onClick={toggleShowCustomerTable}
                >
                  <Icon size="large">
                    <FontAwesomeIcon icon="table" size="lg" />
                  </Icon>
                </Button>
              ]}
              icon="globe"
              label="Customer"
              name="CustomerRecIdRef"
              readOnly={!editing || !canEdit}
              value={order.CustomerRecIdRef}
              variables={{
                where: { Active: true, OrderCust: true },
                orderByMulti: ["CustomerNo_ASC"]
              }}
              onChange={handleCustomerSelect}
            />
          </Control>
        </Field>
        <Field>
          <Control expanded>
            <RouteSelect
              showHelp
              addons={[
                <Button
                  disabled={
                    !editing || !order.CustomerRecIdRef || !canEditRoute
                  }
                  style={{ height: "100%" }}
                  onClick={toggleShowRouteTable}
                >
                  <Icon size="large">
                    <FontAwesomeIcon icon="table" size="lg" />
                  </Icon>
                </Button>,
                <Button
                  disabled={
                    !editing || !order.CustomerRecIdRef || !canEditRoute
                  }
                  style={{ height: "100%" }}
                  onClick={handleAddNewRoute}
                >
                  <Icon size="large">
                    <FontAwesomeIcon icon="plus" size="lg" />
                  </Icon>
                </Button>
              ]}
              disabled={!editing || !order.CustomerRecIdRef || !canEditRoute}
              icon="route"
              label="Route"
              name="RouteRecIdRef"
              value={order?.RouteSelected}
              variables={{
                where: {
                  Status: true,
                  CustomerRecIdRef: order.CustomerRecIdRef
                    ? parseInt(order.CustomerRecIdRef)
                    : null
                },
                orderByMulti: ["RouteId_ASC"]
              }}
              onChange={e => handleSelectRoute(null, e)}
            />
          </Control>
        </Field>

        {order.Route && order.RouteRecIdRef && (
          <div className="order-route-info-container">
            {codes?.BookingCatOrders && (
              <Field>
                <Label>Booking Code</Label>
                <Control>
                  <BookingCodeSelect
                    disableDefaults={false}
                    disabled={
                      !editing ||
                      order.PickupDriverRecIdRef ||
                      order.DeliveryDriverRecIdRef
                    }
                    name="BookingCodeRecIdRef"
                    value={order?.BookingCodeRecIdRef}
                    where={{
                      CodeCatgRecIdRef:
                        codes.BookingCatOrders.RecId /* Orders */
                    }}
                    onChange={onChange}
                  />
                </Control>
              </Field>
            )}
            <Control>
              <SystemCodeSelect
                icon="book-open"
                label="Load Type"
                lookup={{ Category: "Route", Code: "LoadType" }}
                name="LoadTypeRecIdRef"
                readOnly={!editing || !canEdit}
                value={order?.LoadTypeRecIdRef}
                onChange={onChange}
              />
            </Control>
          </div>
        )}
      </div>
      {order.BillToRecIdRef && (
        <div className="row" style={{ gridTemplateColumns: "1.3fr 1.3fr 2fr" }}>
          <Field>
            <Control>
              <CustomerSelect
                readOnly
                icon="globe"
                label="Bill To"
                name="BillToRecIdRef"
                showCityAndState={false}
                value={order.BillToRecIdRef}
                variables={{
                  where: { Active: true, BillToCust: true },
                  orderByMulti: ["CustomerNo_ASC"]
                }}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field>
            <Control expanded>
              <Label>Contract</Label>
              <Input
                readOnly
                autocomplete="new"
                name="Contract"
                type="text"
                value={order?.Route?.Contract}
                onChange={onChange}
              />
            </Control>
          </Field>
          <Field kind="group">
            <Control expanded>
              <Label>Route Description</Label>
              <Input
                readOnly
                type="text"
                value={order.Route.RouteDescription}
              />
            </Control>
            <Control>
              <Label>Industrial</Label>
              <BooleanInput
                name="IndustrialFlag"
                readOnly={!editing || !canEdit}
                value={order.Route.IndustrialFlag}
                onChange={onChange}
              />
            </Control>
            <Control>
              <Label>Queens</Label>
              <BooleanInput
                readOnly
                name="MotorOilFlag"
                value={order.Route.MotorOilFlag}
              />
            </Control>
            <Control>
              <Label>No Bill</Label>
              <BooleanInput
                readOnly
                name="NonBill"
                value={order.Route.NonBill}
              />
            </Control>
            <Control>
              <Label>Tolls</Label>
              <BooleanInput readOnly name="Tolls" value={order.Route.Tolls} />
            </Control>
            <Control style={{ width: "12%" }}>
              <Label>Toll Charge</Label>
              <Input
                readOnly
                name="ChargeForTolls"
                step="0.1"
                type="number"
                value={order.Route.ChargeForTolls}
              />
            </Control>
          </Field>
        </div>
      )}
      {order.RouteRecIdRef && (
        <React.Fragment>
          <HorizontalRule margin="1rem 0" />
          <Locations
            adding={adding}
            editing={editing && canEdit}
            order={order}
            onChange={onChange}
          />
          <HorizontalRule margin="1rem 0" />
          <TimeFrames
            editing={editing && canEdit}
            order={order}
            onChange={onTimeFramesChange}
          />
        </React.Fragment>
      )}

      {!adding && order?.RecId && (
        <React.Fragment>
          <HorizontalRule margin="1rem 0" />
          <OrderDetails isDispatcher orderRecId={order.RecId} />
        </React.Fragment>
      )}

      {codes?.ProductCatSale && adding && orderDetails && (
        <React.Fragment>
          <HorizontalRule margin="1rem 0" />
          {orderDetails.length > 0 && (
            <Column.Group style={{ marginBottom: 0 }}>
              <Column size={5}>
                <Label>Product</Label>
              </Column>
              <Column size={6}>
                <Label>Description</Label>
              </Column>
              <Column size={1}>
                <Label>Quantity</Label>
              </Column>
            </Column.Group>
          )}
          {orderDetails.map((inputs, i) => (
            <NewOrderOrderDetailForm
              ProductCatSale={codes.ProductCatSale}
              editing={editing && canEdit}
              inputs={inputs}
              onChange={handleOrderDetailChange(i)}
            />
          ))}
        </React.Fragment>
      )}
      {order.TripKey && <TripList activeTrip={0} tripKeys={[order.TripKey]} />}
    </div>
  );
}

Summary.propTypes = {
  adding: PropTypes.bool,
  onChange: PropTypes.func,
  order: PropTypes.object,
  editing: PropTypes.bool,
  onTimeFramesChange: PropTypes.func,
  handleChangeRoute: PropTypes.func,
  handleChangeCustomer: PropTypes.func,
  orderDetails: PropTypes.array,
  setOrderDetails: PropTypes.func
};
Summary.defaultProps = {
  order: {}
};
export default Summary;
